var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Is)?_c(_vm.Is,{ref:"form",tag:"component",attrs:{"value":_vm.value,"config":_vm.config,"columns":_vm.columns,"empty":true,"clear-empty-string":true},on:{"change":_vm.handleChange}},[_vm._t("button",null,{"slot":"button"})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }